/**
 * Remove global Graphql error message when changing routes
 */
export default function () {
    const errorBox = document.getElementById('gql-critical-error-message')

    if (!errorBox) {
        return
    }

    errorBox.style.display = 'none'
}
